import { useLayoutEffect } from 'react';

export const useMetaDesc = (desc: string) => {
	useLayoutEffect(() => {
		const metaDesc = document.querySelector('meta[name="description"]')!;
		metaDesc.setAttribute('content', desc);
	}, [desc]);
};
